import * as PIXI from 'pixi.js';

export default () => PIXI.utils.uid();

// Saved group ids can sit far above the uid counter after a reload. Catch the
// counter up so the next drawn array gets a higher id than arrays already
// on the roof. Give up if the gap is huge so a corrupt id cannot freeze load.
const MAX_UID_CATCHUP = 2000000;

export function advanceUidPast(ids: Array<number | null | undefined>): void {
  let maxId = 0;
  for (const id of ids) {
    if (typeof id === 'number' && Number.isFinite(id) && id > maxId) {
      maxId = id;
    }
  }
  if (maxId <= 0) {
    return;
  }
  let current = PIXI.utils.uid();
  if (current > maxId) {
    return;
  }
  if (maxId - current > MAX_UID_CATCHUP) {
    return;
  }
  while (current <= maxId) {
    current = PIXI.utils.uid();
  }
}
